/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSavingsTransfer} from '../api'

 export const useQueryGetSavingsTransfer = createReactQueryHook('getSavingsTransfer', getSavingsTransfer)
